import React from "react";
import "pages/transaction/filterTransaction/FilterTransaction.scss";
import "pages/detailPicker/detailPicker.scss";
import { Field, Form } from "react-final-form";
import "../pricing/Pricing.scss";
import { FilterPolygonType } from "./types";
import "./i18n";
import { useTranslation } from "react-i18next";
import DropdownFilter from "component/dropdownFilter/DropdownFilter";
import { AutoComplete, Button } from "@pickit/pickit-components";

export const FilterPolygons: React.FC<FilterPolygonType> = (
  props
): JSX.Element => {
  const { t } = useTranslation();
  return (
    <DropdownFilter title={t("global:filter")} testId={props.testId}>
      <div className="container-fluid display-filter-pricing">
        <div className="container-pricing-row">
          <div className="container-pricing-col">
            <Form
              onSubmit={(value) => {
                props.handleSubmit(value.region);
              }}
              initialValuesEqual={(obj1, obj2) => obj1 === obj2}
              initialValues={props.initialValues}
              mutators={{
                setValue: ([value], state) => {
                  const { lastFormState: prev } = state;
                  if (prev?.dirtyFieldsSinceLastSubmit) {
                    if (props.generalFormDirty) props.regionChanged(value);
                    else {
                      props.regionChanged();
                    }
                  }
                },
              }}
            >
              {({ handleSubmit, form, values }) => (
                <form className="form-filter-polygons" onSubmit={handleSubmit}>
                  <div className="container-pricing-row">
                    <div className="container-pricing-col-sm-5">
                      <Field
                        name="region"
                        label={t("filterPolygon:regionLabel")}
                        onChange={form.mutators.setValue}
                        placeholder={t("filterPolygon:regionPlaceholder")}
                        options={props.regions}
                        testId={`${props.testId}-region`}
                        isValueObject
                      >
                        {(props: any) => <AutoComplete {...props} />}
                      </Field>
                    </div>

                    <div className="container-pricing-col-sm-10 end">
                      <Button
                        hierarchy="secondary"
                        label={t("global:search")}
                        iconName="search"
                        type="submit"
                        testId={`${props.testId}-submit-button`}
                        disabled={!values.region}
                      />
                    </div>
                  </div>
                </form>
              )}
            </Form>
          </div>
        </div>
      </div>
    </DropdownFilter>
  );
};
